import { render } from "./BorderImageOutset.vue?vue&type=template&id=7df882b1&scoped=true&ts=true"
import script from "./BorderImageOutset.vue?vue&type=script&lang=ts"
export * from "./BorderImageOutset.vue?vue&type=script&lang=ts"

import "./BorderImageOutset.vue?vue&type=style&index=0&id=7df882b1&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df882b1"]])

export default __exports__